import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Travel/Hero";
import IndustriesContent from "../components/Travel/IndustriesContent";
import PageTitle from "../components/Travel/PageTitle";

import '../assets/Webdevelopment.css';



const Travel = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<IndustriesContent />
	  	</div>
	)
}

export default Travel;
